module.exports = __webpack_public_path__ + "img/log1.e4e0744a.png";